export default {
  lang: {
    locale: 'fa_IR',
    today: 'امروز',
    now: 'اکنون',
    backToToday: 'بازگشت به امروز',
    ok: 'تأیید',
    clear: 'پاک کردن',
    month: 'ماه',
    year: 'سال',
    timeSelect: 'انتخاب زمان',
    dateSelect: 'انتخاب تاریخ',
    monthSelect: 'انتخاب ماه',
    yearSelect: 'انتخاب سال',
    decadeSelect: 'انتخاب دهه',
    dayFormat: 'D',
    dateFormat: 'jYYYY/jMM/jDD',
    dateTimeFormat: 'jYYYY/jMM/jDD HH:mm:ss',
    monthBeforeYear: true,
    previousMonth: 'ماه قبل (PageUp)',
    nextMonth: 'ماه بعد (PageDown)',
    previousYear: 'سال قبل (Control + left)',
    nextYear: 'سال بعد (Control + right)',
shortWeekDays: ['یک‌شنبه', 'دو‌شنبه', 'سه‌شنبه', 'چهار‌شنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'],
weekDays: ['یک‌شنبه', 'دو‌شنبه', 'سه‌شنبه', 'چهار‌شنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'],
    placeholder: 'تاریخ را انتخاب کنید',
  },
  timePickerLocale: {
    placeholder: 'زمان را انتخاب کنید',
  },
  dateFormat: 'jYYYY/jMM/jDD',
  weekFormat: 'jYYYY-هفته W',
  monthFormat: 'jYYYY/jMM',
};